(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoosier-bundle-contents"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hoosier-bundle-list')) {
    customElements.define('hoosier-bundle-list', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) {
          this.updateDetails(this.mediaQuery);
          this.mediaQuery.addEventListener('change', this.updateDetails);
          return;
        }
        this.dataset.initialized = 'true';
        this.menuGroups = Array.from(this.querySelectorAll('[data-menu-group]'), element => ({
          handles: JSON.parse(element.dataset.handles || '[]') || []
        }));
        this.mediaQuery = window.matchMedia('(min-width: 750px)');
        this.updateDetails = event => {
          this.querySelectorAll('[data-bundle-details]').forEach(detail => { detail.open = event.matches; });
        };
        this.updateDetails(this.mediaQuery);
        this.mediaQuery.addEventListener('change', this.updateDetails);
        this.querySelectorAll('[data-bundle-card]').forEach(card => this.loadBundle(card));
      }
      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.updateDetails);
      }
      async loadBundle(card) {
        const status = card.querySelector('[data-bundle-status]');
        const list = card.querySelector('[data-bundle-items]');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const names = JSON.parse(card.dataset.optionNames);
          const values = JSON.parse(card.dataset.optionValues);
          const options = names.map((name, index) => ({ name, value: values[index] }));
          const response = await fetch(this.dataset.root + 'api/2026-10/graphql.json', {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Content-Type': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({
              query: 'query BundleVariantContents($handle:String!,$options:[SelectedOptionInput!]!){product(handle:$handle){variantBySelectedOptions(selectedOptions:$options){id components(first:30){nodes{quantity productVariant{title product{title handle}}} pageInfo{hasNextPage}}}}}',
              variables: { handle: card.dataset.handle, options }
            })
          });
          if (!response.ok) throw new Error('Bundle response unavailable');
          const result = await response.json();
          if (result.errors?.length) throw new Error('Bundle query unavailable');
          const variant = result.data?.product?.variantBySelectedOptions;
          if (!variant || variant.id !== card.dataset.variantId || variant.components.pageInfo.hasNextPage) throw new Error('Bundle selection unavailable');
          const items = variant.components.nodes;
          if (!items.length) throw new Error('Bundle contents unavailable');
          items.forEach(item => {
            if (!item.productVariant?.product || !Number.isInteger(item.quantity) || item.quantity < 1) throw new Error('Incomplete bundle contents');
          });
          const saved = JSON.parse(this.dataset.menuOrder || '{}');
          const order = [
            ...(saved.staples || []),
            ...(this.menuGroups[0]?.handles || []), ...(saved.big_four || []),
            ...(saved.salads || []),
            ...(this.menuGroups[1]?.handles || []), ...(saved.grab_go || []),
            ...(this.menuGroups[2]?.handles || []), ...(saved.everready || [])
          ];
          const ranks = new Map();
          order.forEach(handle => { if (!ranks.has(handle)) ranks.set(handle, ranks.size); });
          const sorted = items.map((item, index) => ({ item, index })).sort((a, b) =>
            (ranks.get(a.item.productVariant.product.handle) ?? order.length) -
            (ranks.get(b.item.productVariant.product.handle) ?? order.length) || a.index - b.index
          );
          const rows = document.createElement('ul');
          rows.className = 'hbc__items';
          rows.setAttribute('role', 'list');
          sorted.forEach(({ item }) => rows.append(this.renderItem(item)));
          if (!this.isConnected) return;
          list.replaceChildren(rows);
          list.hidden = false;
          status.hidden = true;
        } catch {
          list.hidden = true;
          status.textContent = this.dataset.error;
          status.hidden = false;
        } finally {
          clearTimeout(timeout);
        }
      }
      renderItem(item) {
        const row = document.createElement('li');
        row.className = 'hbc__item';
        const quantity = document.createElement('span');
        quantity.className = 'hbc__quantity';
        quantity.textContent = item.quantity + ' ×';
        quantity.setAttribute('aria-label', this.dataset.quantity + ': ' + item.quantity);
        const description = document.createElement('span');
        const name = document.createElement('span');
        name.className = 'hbc__name';
        name.textContent = item.productVariant.product.title;
        description.append(name);
        const title = item.productVariant.title;
        if (title && title !== 'Default Title') {
          const size = document.createElement('span');
          size.className = 'hbc__size';
          size.textContent = title === 'Single' ? this.dataset.single : title === 'Family' ? this.dataset.family : title;
          description.append(size);
        }
        row.append(quantity, description);

        return row;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
